// src/components/Header.tsx

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const HeaderContainer = styled.div`
  width: 100%;
  height: 80px;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 250px;
  padding-right: 250px;
  box-sizing: border-box;

  @media (max-width: 1550px) {
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
`;

const Logo = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: "Pretendard";
`;

const Nav = styled.nav<{ isOpen: boolean }>`
  display: flex;
  gap: 20px;

  @media (max-width: 1550px) {
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")}; // 상태에 따라 표시
    flex-direction: column;
    position: absolute;
    top: 80px;
    right: 10px;
    background-color: #444;
    padding: 10px;
    border-radius: 8px;
    z-index: 10;
  }
`;

const NavItem = styled(NavLink)`
  color: white;
  text-decoration: none;
  font-size: 18px;
  display: flex;
  font-family: "Pretendard";

  &:hover {
    font-weight: bold;
  }

  &.active {
    border-bottom: 2px solid white;
  }
`;

const MenuIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 1550px) {
    display: block;
    font-size: 24px;
    color: white;
  }
`;

const Image = styled.img`
  width: 180px;
`;

function Header() {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <HeaderContainer>
      <Image src={'/images/logo.png'} />
      <Logo></Logo>
      <MenuIcon onClick={toggleMenu}>{isMenuOpen ? "X" : "☰"}</MenuIcon>
      <Nav isOpen={isMenuOpen}>
        <NavItem exact to="/" activeClassName="active" onClick={closeMenu}>
          회사소개
        </NavItem>
        <NavItem to="/marketing" activeClassName="active" onClick={closeMenu}>
          마케팅
        </NavItem>
        <NavItem to="/itsolutions" activeClassName="active" onClick={closeMenu}>
          IT솔루션
        </NavItem>
        <NavItem to="/portfolio" activeClassName="active" onClick={closeMenu}>
          포트폴리오
        </NavItem>
      </Nav>
    </HeaderContainer>
  );
}

export default Header;
